<template>
  <v-container fluid>
    <v-layout row justify-center>
      <!--<v-btn slot="activator" flat icon @click.native="allDashboard" small dark>-->
        <!--<v-icon>refresh</v-icon>-->
      <!--</v-btn>-->
      <v-flex lg12 md12>.
        <v-card dark>
          <v-card-title>
            All Dashboard Name

            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="allDash"
            :search="search"
            :loading="loadTable"
            :pagination.sync="pagination"
            >
            <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.customer_name}}</td>
              <td class="text-xs-left">{{ props.item.username }}</td>
              <td class="text-xs-left">{{ props.item.templatename }}</td>
              <td class="text-xs-left">{{ props.item.index_name }}</td>
              <!--<td class="text-xs-center">{{ props.item.instance }}</td>-->
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="linkItem(props.item)">
                  visibility
                </v-icon>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'

export default {
  name: 'allDashboard',
  data () {
    return {
      allDash: [],
      search: '',
      headers: [
        {
          text: 'Customer Name',
          value: 'customer_name',
          align: 'left',
          sortable: true
        },
        {
          text: 'Username',
          value: 'username',
          align: 'left',
          sortable: true
        },
        {
          text: 'Template Name',
          value: 'templatename',
          align: 'left',
          sortable: true
        },
        {
          text: 'Index Name',
          value: 'index_name',
          align: 'left',
          sortable: true
        },
        {
          text: 'Actions',
          value: 'name',
          align: 'center',
          sortable: false
        }
      ],
      pagination: {
        descending: false,
        rowsPerPage: 25,
        sortBy: 'username'
      },
      loadTable: false,
      ampid: null
    }
  },
  created () {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.user_index = this.decoded.index
    this.ampid = this.decoded.ampid
    this.role = this.decoded.role
    this.allDashboard()
  },
  methods: {
    // FIXME: Security role
    /* Feed table data */
    async allDashboard () {
      this.loadTable = true
      try {
        let response = await axios.post(apiUrl + '/api/dashboard/load_all_dashboard', {
          role: this.role,
          type: 'allDashboard'
        })
        this.allDash = response.data.allDashboard
        this.loadTable = false
      } catch (error) {
        console.error(error)
        alert(error)
      }
    },
    linkItem (item) {
      if (item.type === 'pdpa') {
        this.$router.push({
        name: 'dashboardpdpa',
          params: {
            id: item._id,
            username: item.username,
            templateName: item.templatename,
            index_name: item.index_name,
            user_inst: item.instance,
            index_list: item.index_list,
            customer_name: item.customer_name
          }
        })
      } else {
        this.$router.push({
          name: 'dashboard',
          params: {
            id: item._id,
            username: item.username,
            templateName: item.templatename,
            index_name: item.index_name,
            user_inst: item.instance,
            index_list: item.index_list,
            customer_name: item.customer_name
          }
        })
      }
      // this.$router.push({
      //   name: 'dashboard',
      //   params: {
      //     username: item.username,
      //     templateName: item.templatename,
      //     index_name: item.index_name,
      //     user_inst: item.instance,
      //     index_list: item.index_list,
      //     customer_name: item.customer_name
      //   }
      // })
    }
  },
  watch: {
    search: function () {
        window.analytics.track(`[Administrator][All Dashboard][Search]`, {
           value: {
                keyword: this.search
            }
        },
        {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/alldashboard.vue